import { updateUser, clearUser } from './userActions';
import { clearUserSecurityStatus } from './utilityActions';
import { callApi } from '../utils';

export const AUTHENTICATE = 'AUTHENTICATE';
export const UNAUTHENTICATE = 'UNAUTHENTICATE';

export const authenticate = () => ({ type: AUTHENTICATE });

export const unAuthenticate = () => ({ type: UNAUTHENTICATE });

export const logout = (api = true) => (dispatch, getState) => {
  const phone = getState().user.phone;

  // HACK! clear user store, keep phone
  dispatch(clearUser());
  dispatch(updateUser({ phone }));
  
  dispatch(clearUserSecurityStatus());

  // Logout
  dispatch(unAuthenticate());

  // Call Logout API
  api && callApi('/logout').catch();
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js